export enum CurrencyType {
  FIAT = "fiat",
  CRYPTO = "crypto",
}

export interface CurrencyUnit {
  name: string;
  value: string;
  sub_unit: number;
  currency_type: CurrencyType;
}
